export enum TemplateType {
    SingleSlotQuestionTemplate = 'QUESTION_TEMPLATE_SINGLE_CONTROL',
    MultiSlotQuestionTemplate = 'MULTI_SLOT_QUESTION_TEMPLATE',
    CombinedSlotQuestionTemplate = 'COMBINED_SLOT_QUESTION_TEMPLATE'
}
